import { isDate, isPlainObject, isURLSearchParams } from './util'

interface URLOrigin {
  protocol: string
  host: string
}

// 对encode 做特殊处理，有些字符又转换回来，不做encode
function encode(val: string): string {
  return encodeURIComponent(val)
    .replace(/%40/g, '@')
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/g, '+')
    .replace(/%5B/gi, '[')
    .replace(/%5D/gi, ']')
}

export function buildURL(
  url: string,
  params?: any,
  paramsSerializer?: (params: any) => string
): string {
  if (!params) return url
  let serializedParams

  if (paramsSerializer) {
    serializedParams = paramsSerializer(params)
  } else if (isURLSearchParams(params)) {
    serializedParams = params.toString()
  } else {
    const parts: string[] = []
    Object.keys(params).forEach(key => {
      const val = params[key]
      // 如果值是null 或是undefined 则跳出循环
      if (val === null || typeof val === 'undefined') return
      let values = []
      if (Array.isArray(val)) {
        values = val
        key += '[]'
      } else {
        values = [val]
      }
      values.forEach(val => {
        if (isDate(val)) {
          val = val.toISOString()
        } else if (isPlainObject(val)) {
          val = JSON.stringify(val)
        }
        // 将key, val 都encode
        parts.push(`${encode(key)}=${encode(val)}`)
      })
    })
    // 将params 用& 链接
    serializedParams = parts.join('&')
  }
  // 排除url上的hash
  if (serializedParams) {
    const markIndex = url.indexOf('#')
    if (markIndex !== -1) {
      url = url.slice(0, markIndex)
    }
    // 将params拼接到url上, 判断url上是否已有参数
    url += `${url.indexOf('?') === -1 ? '?' : '&'}${serializedParams}`
  }
  return url
}

// 判断url 是否是一个绝对地址
export function isAbsoluteURL(url: string): boolean {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
}

// 拼接url(将baseURL 最后的// 和relativeURL 最前面的 // 去掉, 然后拼接， 防止出现多个斜线)
export function combineURL(baseURL: string, relativeURL?: string): string {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL
}

// 通过协议或是域名来判断是否为同源请求
export function isURLSameOrigin(requestURL: string): boolean {
  const parsedOrigin = resolveURL(requestURL) // 请求接口的origin
  return (
    parsedOrigin.protocol === currentOrigin.protocol && parsedOrigin.host === currentOrigin.host
  )
}

// 通过把url传给a节点的href， 然后可以通过解析node对象得到protocol， host
const urlParsingNode = document.createElement('a')
const currentOrigin = resolveURL(window.location.href) // 当前页面的origin

function resolveURL(url: string): URLOrigin {
  urlParsingNode.setAttribute('href', url)
  const { protocol, host } = urlParsingNode
  return {
    protocol,
    host
  }
}
